export default __webpack_public_path__ + "static/media/Image-Gallery.978fa2c6.jpg";